import { useEffect, useState, useRef } from "react";
import addConductor from "../../../api/add/addConductor";
import addExpert from "../../../api/add/addExpert";
import addOperator from "../../../api/add/addOperator";
import removeConductor from "../../../api/removeConductor";
import removeOperator from "../../../api/removeOperator";
import SecondaryButton from "../../../buttons/SecondaryButton";
import { getOrRefreshFirebaseToken } from "../../../config/getFirebaseToken";
import { addActivityLog } from "../../../config/OnlineStatus";
import CustomAccordion from "../../../layout/CustomAccordion";
import MMName from "../../../members/MMName";
import SmallSpinner from "../../../loading/SmallSpinner";
import updateDocApi from "../../../api/database/updateDocApi";
import addPartner from "../../../api/add/addPartner";
import removePartner from "../../../api/removePartner";
import addClientPartners from "../../../api/add/addClientPartners";
import { all } from "axios";
import updateDocDataFieldApi from "../../../api/database/updateDocDataFieldApi";
import { isFolderAdmin } from "../FolderHelpers";
import { hasInfiltro } from "../../../hexagone/VisibilityHelpers";
import {
  queryCollection,
  getArrayDocDataByID,
} from "../../../models/DataFunctions";
import deleteDocApi from "../../../api/database/deleteDocApi";
import Icon1 from "../../../icons/Icon";

export const FolderCollaboratorsSection = ({
  id,
  orgData,
  userData,
  operators,
  operator_value,
  setOperatorValue,

  assistants,
  assistant_value,
  setAssistantValue,
  operator_options,
  assistant_options,
  handleFetchData,
  folderData,
  conductor_options, // conductor_options is actually all client users. Legacy
  all_operators,
  all_experts,
  all_partner,
  partners,
  all_conductors,
  all_clientusers,
  conductor,
  conductor_value,
  setConductorValue,
  all_assistants,
  partner_options,
  setPartnerValue,
  handleClickVariant,
  prefix,
}) => {
  const [loadingExperts, setLoadingExperts] = useState(false);
  const [loadingOperators, setLoadingOperators] = useState(false);
  const [loadingAssistants, setLoadingAssistants] = useState(false);
  const [loadingConductors, setLoadingConductors] = useState(false);
  const [loadingPartners, setLoadingPartners] = useState(false);
  const [members, setMembers] = useState([]);
  const [all_members, setAllMembers] = useState([]);
  const [loadingMembers, setLoadingMembers] = useState(false);
  const [member_options, setMemberOptions] = useState([]);
  const [loadingClientPartners, setLoadingClientPartners] = useState(false);
  const [memberValue, setMemberValue] = useState(null);
  const [jobReminders, setJobReminders] = useState([]);
  const [loadingJobReminders, setLoadingJobReminders] = useState(false);
  const isFetchingJobRemindersRef = useRef(false);
  const handleFetchMembers = async () => {
    setLoadingMembers(true);
    let members = [operators, assistants].flat();
    // Always include the conductor if it exists (real conductor with role === "conductor")
    if (conductor && !members.find((m) => m.id === conductor.id)) {
      members.push(conductor);
    }
    members = members.filter((member) => member !== null);
    let all_members = [
      all_operators,
      all_assistants,
      all_experts,
      all_conductors,
      members,
    ].flat();
    // remove duplicates from all_members
    all_members = all_members.filter(
      (member, index, self) =>
        index === self.findIndex((m) => m.id === member.id)
    );

    let members_options = all_members.map((member) => {
      return {
        label: member.display_name,
        value: member.id,
        id: member.id,
        type: member.type,
      };
    });
    setMembers(members);
    setAllMembers(all_members);
    setMemberOptions(members_options);
    setLoadingMembers(false);
  };

  const handleAddMember = async (member_value) => {
    // check if member is operator, assistant, expert or conductor
    setLoadingMembers(true);
    const member = all_members.find(
      (member) => member.id === member_value.value
    );
    let is_client_memeber = conductor_options.find(
      (conductor) => conductor.value === member_value.value
    );
    let role = member.role;
    if (role === "operator") {
      await handlenewOperator(member_value);
    } else if (role === "secretary") {
      await handlenewAssistant(member_value);
    } else if (role === "conductor") {
      await handlenewConductor(member_value);
    } else {
      await handlenewAssistant(member_value);
    }
    setMemberValue(null);
    await handleFetchData();

    // If the added member has role "conductor", automatically set them as Conducteur de chantier
    if (role === "conductor") {
      await updateDocDataFieldApi(
        folderData.ref,
        "conductor_id",
        member.id,
        prefix
      );
    }

    handleClickVariant("Membre ajouté", "success");
    setLoadingMembers(false);
  };

  const onDeleteMember = async (member) => {
    setLoadingMembers(true);
    const member_data = all_members.find((mem) => mem.id === member.id);
    let is_client_member = conductor_options.find(
      (conductor) => conductor.value === member.id
    );

    if (member_data) {
      if (member_data.role === "operator") {
        await onDeleteOperator(member_data);
      } else if (member_data.role === "secretary") {
        await onDeleteAssistant(member_data);
      } else if (member_data.role === "conductor" || is_client_member) {
        await onDeleteConductor(member_data);
      } else {
        console.error("Unknown role: ", member_data.role);
      }
    } else {
      console.error("Member not found: ", member);
    }
    // If the deleted member was the Conducteur de chantier, clear the conductor_id
    if (folderData.conductor_id === member.id) {
      await updateDocDataFieldApi(folderData.ref, "conductor_id", null, prefix);
    }

    setMemberValue(null);
    await handleFetchData();
    setLoadingMembers(false);
    handleClickVariant("Membre retiré", "success");
  };

  useEffect(() => {
    if (operators && assistants && all_experts && all_conductors) {
      handleFetchMembers();
    }
  }, [operators, assistants, all_experts, all_conductors]);

  useEffect(() => {
    if (folderData && folderData.ref && !isFetchingJobRemindersRef.current) {
      handleFetchJobReminders();
    }
  }, [folderData?.id]); // Use only the ID to prevent loop when folderData object reference changes

  const handlenewAssistant = async (assistant_value) => {
    setLoadingAssistants(true);
    let ass = all_assistants.find((asss) => asss?.id === assistant_value.value);
    if (!ass) {
      ass = conductor_options.find(
        // conductor_options is actually all client users. Legacy
        (client) => client.value === assistant_value.value
      );
    }
    let current_assistants_id = folderData.assistants_id || [];
    if (!current_assistants_id.includes(ass?.id) && ass) {
      let new_ass_id = [...current_assistants_id, ass.id];
      await updateDocApi(
        folderData.ref,
        { assistants_id: new_ass_id, assistant_name: ass.display_name },
        prefix
      );
    }
    setAssistantValue(null);

    await handleFetchData();
    setLoadingAssistants(false);
  };

  const handleAddClientPartners = async () => {
    setLoadingClientPartners(true);
    const token = await getOrRefreshFirebaseToken();
    await addClientPartners(id, folderData.client_id, token, prefix);
    handleClickVariant("Partenaires ajoutés", "success");
    await handleFetchData();
    setLoadingClientPartners(false);
  };

  const onDeleteAssistant = async (assistant) => {
    setLoadingAssistants(true);

    let current_assistants_id = folderData.assistants_id || [];
    let new_assistants = assistants.filter((ass) => ass.id !== assistant.id);
    let new_assistants_id = current_assistants_id.filter(
      (ass_id) => ass_id !== assistant.id
    );

    await updateDocApi(
      folderData.ref,
      {
        assistants_id: new_assistants_id,
        assistant_name:
          new_assistants?.length > 0 ? new_assistants[0].display_name : "",
      },
      prefix
    );

    setAssistantValue(null);

    await handleFetchData();
    setLoadingAssistants(false);
  };
  const handlenewOperator = async (operator_selected) => {
    const token = await getOrRefreshFirebaseToken();
    setLoadingOperators(true);
    const operator = all_operators.find(
      (operator) => operator.id === operator_selected.value
    );
    await addOperator(operator.id, id, token, prefix);
    setOperatorValue(null);

    await handleFetchData();
    setLoadingOperators(false);
  };
  const handlenewConductor = async (conductor_selected) => {
    const token = await getOrRefreshFirebaseToken();

    setLoadingConductors(true);
    const conductor = all_conductors.find(
      (conductor) => conductor.id === conductor_selected.value
    );
    await addConductor(conductor.id, id, token, prefix);
    await updateDocDataFieldApi(
      folderData.ref,
      "conductor_name",
      conductor.display_name,
      prefix
    );

    setConductorValue(null);
    await handleFetchData();
    setLoadingConductors(false);
  };

  const handlenewPartner = async (partner_selected) => {
    setLoadingPartners(true);

    const partner = all_partner.find(
      (partner) => partner.id === partner_selected.value
    );
    const token = await getOrRefreshFirebaseToken();

    await addPartner(partner.id, id, token, prefix);
    await addActivityLog(
      "Partenaire ajouté " + partner.name,
      folderData.ref,
      orgData.id,
      userData.id,
      "partner_added",
      prefix
    );
    setPartnerValue(null);
    await handleFetchData();
    handleClickVariant("Partenaire ajouté", "success");
    setLoadingPartners(false);
  };
  const onDeleteOperator = async (operator) => {
    setLoadingOperators(true);
    const token = await getOrRefreshFirebaseToken();

    await removeOperator(operator.id, id, token, prefix);
    await addActivityLog(
      "Opérateur retiré",
      folderData.ref,
      orgData.id,
      userData.id,
      "operator_removed",
      prefix
    );
    await handleFetchData();
    setLoadingOperators(false);
  };
  const onDeletePartner = async (partner) => {
    setLoadingPartners(true);
    const new_partners = partners.filter((part) => part !== partner);
    const token = await getOrRefreshFirebaseToken();

    await removePartner(partner.id, id, token, prefix);
    await addActivityLog(
      "Partenaire retiré " + partner.name,
      folderData.ref,
      orgData.id,
      userData.id,
      "partner_removed",
      prefix
    );
    await handleFetchData();
    handleClickVariant("Partenaire retiré", "success");
    setLoadingPartners(false);
  };
  const onDeleteConductor = async () => {
    setLoadingConductors(true);
    const token = await getOrRefreshFirebaseToken();
    await removeConductor(id, token, prefix);
    await addActivityLog(
      "Opérateur retiré",
      folderData.ref,
      orgData.id,
      userData.id,
      "operator_removed",
      prefix
    );
    await updateDocDataFieldApi(folderData.ref, "conductor_name", null, prefix);
    await handleFetchData();
    setLoadingConductors(false);
  };

  const handleSetConducteurDeChantier = async (member) => {
    if (!hasInfiltro(orgData)) {
      handleClickVariant("Accès non autorisé", "error");
      return;
    }

    setLoadingMembers(true);

    // Check if this member is already the conducteur
    const isCurrentConducteur = folderData.conductor_id === member.id;

    if (isCurrentConducteur) {
      // Remove conducteur de chantier
      await updateDocDataFieldApi(folderData.ref, "conductor_id", null, prefix);
      handleClickVariant("Conducteur de chantier retiré", "success");
    } else {
      // Set as conducteur de chantier
      await updateDocDataFieldApi(
        folderData.ref,
        "conductor_id",
        member.id,
        prefix
      );
      handleClickVariant("Conducteur de chantier défini", "success");
    }

    await handleFetchData();
    setLoadingMembers(false);
  };

  const handleFetchJobReminders = async () => {
    if (isFetchingJobRemindersRef.current) {
      return;
    }

    isFetchingJobRemindersRef.current = true;
    setLoadingJobReminders(true);
    try {
      const filters = [
        { field: "folder_ref", operator: "==", value: folderData.ref },
        { field: "type", operator: "in", value: ["xml", "folder_doc"] },
      ];

      const jobs = await queryCollection("job", filters);

      // Fetch document details for folder_doc jobs and check completion status
      const jobsWithDocs = await Promise.all(
        jobs.map(async (job) => {
          if (
            job.type === "folder_doc" &&
            job.folder_docs_id &&
            job.folder_docs_id.length > 0
          ) {
            try {
              // Fetch the specific documents requested in this job
              const documents = await getArrayDocDataByID(
                "document",
                job.folder_docs_id
              );

              // Check if all requested documents are done (state === "done")
              const allDocumentsDone = documents.every(
                (doc) => doc.state === "done"
              );

              // If all documents are done and job is not already completed, mark it as completed
              if (allDocumentsDone && job.status !== "completed") {
                try {
                  await updateDocDataFieldApi(
                    job.ref,
                    {
                      status: "completed",
                      completed: true,
                    },
                    prefix
                  );

                  // Update the job object to reflect the new status
                  return {
                    ...job,
                    requestedDocuments: documents,
                    status: "completed",
                    completed: true,
                  };
                } catch (updateError) {
                  console.error("Error updating job status:", updateError);
                  return { ...job, requestedDocuments: documents };
                }
              }

              return { ...job, requestedDocuments: documents };
            } catch (error) {
              console.error("Error fetching documents for job:", job.id, error);
              return { ...job, requestedDocuments: [] };
            }
          }
          return job;
        })
      );

      // Filter to show only pending reminders
      const pendingJobs = jobsWithDocs.filter(
        (job) => job.status === "pending"
      );

      setJobReminders(pendingJobs);
    } catch (error) {
      console.error("Error fetching job reminders:", error);
      handleClickVariant("Erreur lors du chargement des rappels", "error");
    } finally {
      setLoadingJobReminders(false);
      isFetchingJobRemindersRef.current = false;
    }
  };

  const handleDeleteJobReminder = async (jobRef) => {
    try {
      setLoadingJobReminders(true);
      await deleteDocApi(jobRef, prefix);
      handleClickVariant("Rappel supprimé", "success");
      await handleFetchJobReminders();
    } catch (error) {
      console.error("Error deleting job reminder:", error);
      handleClickVariant("Erreur lors de la suppression", "error");
      setLoadingJobReminders(false);
    }
  };

  return (
    <>
      <>
        {false && (
          <CustomAccordion userData={userData} title="Old Collaborateurs">
            <div className="flex flex-col gap-1 mb-4 mt-2 max-w-full w-full">
              <div className="flex flex-row w-full justify-between border-1 border-shadow_10 rounded-md p-2 gap-2">
                <div className="flex w-1/2">
                  <MMName
                    label="Opérateurs assignés"
                    className="flex-grow"
                    icon_name="user"
                    removable={true}
                    users={operators == null ? [] : operators}
                    options={operator_options == null ? [] : operator_options}
                    value={operator_value}
                    setValue={setOperatorValue}
                    onAction={handlenewOperator}
                    loading={loadingOperators}
                    onDelete={onDeleteOperator}
                    type="user"
                  ></MMName>{" "}
                </div>{" "}
                <div className="flex w-1/2">
                  <MMName
                    label="Assistants techniques assignés"
                    className="flex-grow"
                    icon_name="user"
                    removable={true}
                    users={assistants == null ? [] : assistants}
                    options={assistant_options == null ? [] : assistant_options}
                    value={assistant_value}
                    setValue={setAssistantValue}
                    onAction={handlenewAssistant}
                    loading={loadingAssistants}
                    onDelete={onDeleteAssistant}
                    type="user"
                  ></MMName>
                </div>
              </div>
              <div className="flex flex-col gap-1">
                <div className="flex flex-row w-full justify-between border-1 border-shadow_10 rounded-md p-2 gap-2">
                  <div className="flex w-1/2">
                    <MMName
                      label="Conducteur de chantier assigné"
                      icon_name="client"
                      className="flex-grow"
                      users={conductor == null ? [] : [conductor]}
                      removable={true}
                      options={
                        conductor_options == null ? [] : conductor_options
                      }
                      value={conductor_value}
                      setValue={setConductorValue}
                      onAction={handlenewConductor}
                      onDelete={onDeleteConductor}
                      loading={loadingConductors}
                      type="user"
                    ></MMName>{" "}
                  </div>
                  <div className="flex flex-col gap-1 w-1/2">
                    <MMName
                      label="Partenaires invités"
                      users={partners == null ? [] : partners}
                      removable={true}
                      className="flex-grow"
                      options={partner_options}
                      value={null}
                      loading={loadingPartners}
                      placeholder={"Entreprise"}
                      setValue={setPartnerValue}
                      onAction={handlenewPartner}
                      onDelete={onDeletePartner}
                      type="org"
                    ></MMName>{" "}
                    <div className="flex flex-row justify-end">
                      <SecondaryButton
                        onClick={handleAddClientPartners}
                        disabled={loadingClientPartners}
                        className={"w-fit"}
                      >
                        Ajouter les partenaires du client
                        <SmallSpinner
                          loading={loadingClientPartners}
                          margin={0}
                          size={20}
                        />
                      </SecondaryButton>{" "}
                    </div>{" "}
                  </div>
                </div>
              </div>
            </div>
          </CustomAccordion>
        )}

        <CustomAccordion userData={userData} title="Collaborateurs">
          <div className="flex flex-col gap-1 mb-4 mt-2 max-w-full w-full">
            <div className="flex flex-col gap-1">
              <div className="flex flex-row w-full justify-between border-1 border-shadow_10 rounded-md p-2 gap-2">
                <div className="flex w-1/2">
                  <MMName
                    label="Opérateur, assistant et conducteur"
                    icon_name="client"
                    className="flex-grow"
                    users={members}
                    removable={true}
                    options={member_options}
                    value={memberValue}
                    setValue={setMemberValue}
                    onAction={handleAddMember}
                    onDelete={onDeleteMember}
                    loading={loadingMembers}
                    type="user"
                    onSetConducteur={handleSetConducteurDeChantier}
                    folderData={folderData}
                    orgData={orgData}
                  ></MMName>{" "}
                </div>
                <div className="flex flex-col gap-1 w-1/2">
                  <MMName
                    label="Partenaires invités"
                    users={partners == null ? [] : partners}
                    removable={true}
                    className="flex-grow"
                    options={partner_options}
                    value={null}
                    loading={loadingPartners}
                    placeholder={"Entreprise"}
                    setValue={setPartnerValue}
                    onAction={handlenewPartner}
                    onDelete={onDeletePartner}
                    type="org"
                  ></MMName>{" "}
                  {!folderData.client_type === "particulier" && (
                    <div className="flex flex-row justify-end">
                      <SecondaryButton
                        onClick={handleAddClientPartners}
                        disabled={loadingClientPartners}
                        className={"w-fit"}
                      >
                        Ajouter les partenaires du client
                        <SmallSpinner
                          loading={loadingClientPartners}
                          margin={0}
                          size={20}
                        />
                      </SecondaryButton>{" "}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </CustomAccordion>

        {orgData.id === folderData.master_id && (
          <CustomAccordion userData={userData} title="Rappels automatiques">
            <div className="flex flex-col gap-4 mb-4 mt-2 max-w-full w-full">
              {loadingJobReminders ? (
                <div className="flex justify-center p-4">
                  <SmallSpinner loading={true} size={30} />
                </div>
              ) : jobReminders.length === 0 ? (
                <div className="text-h3 text-shadow_50 p-4 text-center">
                  Aucun rappel automatique en attente
                </div>
              ) : (
                <div className="flex flex-col gap-2">
                  {jobReminders.map((job, index) => (
                    <div
                      key={job.id || index}
                      className="border border-shadow_10 rounded-lg p-3"
                    >
                      <div className="flex flex-row justify-between items-start">
                        <div className="flex flex-col gap-2 flex-1">
                          <div className="flex flex-row items-center gap-3">
                            <div className="px-2 py-1 rounded text-h4 bg-yellow-100 text-yellow-700">
                              En attente
                            </div>
                            <div
                              className={`px-2 py-1 rounded text-h4 ${
                                job.type === "xml"
                                  ? "bg-blue-100 text-blue-700"
                                  : "bg-purple-100 text-purple-700"
                              }`}
                            >
                              {job.type === "xml"
                                ? "Relance XML"
                                : "Relance Documents"}
                            </div>
                          </div>

                          <div className="text-h3 font-semibold">
                            {job.subject || "Sans objet"}
                          </div>

                          <div className="text-h4 text-shadow_75">
                            <strong>Destinataire:</strong>{" "}
                            {job.emails && job.emails.length > 0
                              ? job.emails.join(", ")
                              : "Non spécifié"}
                          </div>

                          {job.type === "folder_doc" &&
                            job.requestedDocuments &&
                            job.requestedDocuments.length > 0 && (
                              <div className="text-h4 text-shadow_75">
                                <strong>Pièces demandées:</strong>
                                <div className="flex flex-wrap gap-1 mt-1">
                                  {job.requestedDocuments.map((doc, docIndex) => {
                                    const isDone = doc.state === "done";
                                    return (
                                      <span
                                        key={docIndex}
                                        className={`px-2 py-1 rounded text-h4 ${
                                          isDone
                                            ? "bg-green-100 text-green-700"
                                            : "bg-yellow-100 text-yellow-700"
                                        }`}
                                      >
                                        {doc.name ||
                                          doc.title ||
                                          `Document ${docIndex + 1}`}
                                      </span>
                                    );
                                  })}
                                </div>
                              </div>
                            )}

                          {job.trigger_date &&
                            !(
                              job.type === "folder_doc" &&
                              job.requestedDocuments &&
                              job.requestedDocuments.every(
                                (doc) => doc.state === "done"
                              )
                            ) && (
                              <div className="text-h4 text-shadow_75">
                                <strong>Prochaine échéance:</strong>{" "}
                                {job.trigger_date.seconds
                                  ? new Date(
                                      job.trigger_date.seconds * 1000
                                    ).toLocaleDateString("fr-FR")
                                  : new Date(job.trigger_date).toLocaleDateString(
                                      "fr-FR"
                                    )}
                              </div>
                            )}

                          <div className="text-h4 text-shadow_75">
                            <strong>Fréquence:</strong>{" "}
                            {job.type === "folder_doc"
                              ? `${job.frequency || 5} jours`
                              : job.type === "xml"
                                ? "5 jours"
                                : "Non spécifiée"}
                          </div>

                          {job.counter !== undefined && (
                            <div className="text-h4 text-shadow_75">
                              <strong>Nombre d'envois:</strong> {job.counter + 1}
                            </div>
                          )}
                        </div>

                        {isFolderAdmin(orgData, folderData) && (
                          <button
                            onClick={() => handleDeleteJobReminder(job.ref)}
                            disabled={loadingJobReminders}
                            className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-red-100 text-red-600 transition-colors"
                            title="Supprimer le rappel"
                          >
                            <Icon1 icon_name="delete" size={16} />
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </CustomAccordion>
        )}
      </>
    </>
  );
};
